export default "/images/icons8-germany.png?987569b945628e37c8fae1b8d890ad3b";